<template>
  <div>
    <legend class="legend-title">
      <TaskCheckCircle
        class="mr-1"
        :show-check="hasWebhookConfigured"
      />
      Conversion Webhook (Only required for CPA categories)
    </legend>

    <div class="form-group form-row">
      <label class="col-lg-3 col-form-label text-left text-sm-right custom-form-input-label--internal pr-4">
        Select Webhook
      </label>
      <div class="col-lg-6">
        <div
          v-if="loading"
          class="d-flex align-items-center pt-2"
        >
          <b-spinner
            small
            class="mr-2"
          />
          <span class="text-muted">Loading webhooks...</span>
        </div>
        <b-form-select
          v-else
          v-model="selectedWebhookId"
          :options="webhookOptions"
          :disabled="saving"
          class="custom-form-input custom-form-input--sm"
        >
          <template #first>
            <b-form-select-option
              :value="null"
              disabled
            >
              {{ webhookOptions.length === 0 ? 'No webhooks available' : 'Select a webhook' }}
            </b-form-select-option>
          </template>
        </b-form-select>
      </div>
    </div>

    <BaseButtonLoader
      v-if="!loading"
      horizontal
      internal-platform-input
      variant="primary"
      :disabled="!hasChanges"
      :loading="saving"
      size="sm"
      @click="saveWebhookSelection"
    >
      Update
    </BaseButtonLoader>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { showErrorMessage, showSuccessMessage } from '@/notification-utils'
import TaskCheckCircle from '@/components/common/TaskCheckCircle.vue'

export default {
  name: 'SelectedWebhookDisplay',

  components: {
    TaskCheckCircle
  },

  props: {
    accountId: {
      type: String,
      required: true
    }
  },

  data() {
    return {
      selectedWebhookId: null,
      loading: false,
      saving: false
    }
  },

  computed: {
    ...mapGetters('sellerWebhooks', ['sellerWebhook', 'availableWebhooks', 'hasWebhookConfigured']),

    webhookOptions() {
      return this.availableWebhooks.map(webhook => ({
        value: webhook.id,
        text: webhook.name || webhook.endPointUrl || webhook.id
      }))
    },

    hasChanges() {
      return this.selectedWebhookId && this.selectedWebhookId !== this.sellerWebhook?.ringbaWebhookId
    }
  },

  async created() {
    await this.loadData()
  },

  methods: {
    ...mapActions('sellerWebhooks', ['fetchSellerWebhook', 'fetchRingbaWebhooks', 'selectWebhook']),

    async loadData() {
      this.loading = true
      try {
        await Promise.all([
          this.fetchSellerWebhook({ accountId: this.accountId }),
          this.fetchRingbaWebhooks({ accountId: this.accountId })
        ])
        // Pre-select current webhook if exists
        if (this.sellerWebhook?.ringbaWebhookId) {
          this.selectedWebhookId = this.sellerWebhook.ringbaWebhookId
        }
      } catch (error) {
        showErrorMessage(error.response?.data?.title || 'Failed to load webhook data')
      } finally {
        this.loading = false
      }
    },

    async saveWebhookSelection() {
      if (!this.selectedWebhookId) return

      try {
        this.saving = true
        await this.selectWebhook({
          accountId: this.accountId,
          ringbaWebhookId: this.selectedWebhookId
        })
        showSuccessMessage('Webhook saved successfully')
      } catch (error) {
        showErrorMessage(error.response?.data?.title || error.message)
      } finally {
        this.saving = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
